<template>
  <div>
    <Header :linkData="this.linkCall()" />
    <div class="hero_price">
      <div class="copy_hero_price">
        <h1>
          Cree su tienda en linea de una manera
          <span>fácil</span> y rápida.
        </h1>
        <p>Selección el plan que más se ajuste a su negocio.</p>
      </div>
    </div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" md="12" sm="12">
          <div class="hero_price_title">
            <h1>
              Prueba Lubumas por
              <b>30 días</b>,
              <br />sin compromiso
            </h1>
          </div>
          <div class="switch_periodo">
            <div>
              <p>MES</p>
            </div>
            <div>
              <v-switch color="#114B5F" inset v-model="active"></v-switch>
            </div>
            <div>
              <p>AÑO</p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6" sm="6">
          <div class="table_price">
            <div class="col-price">
              <div class="copy_price">
                <p class="title">Personal</p>
                <p class="price">{{priceYear | currency}}/{{yearCopy}}</p>
                <v-btn disabled class="btn_price" elevation="2" raised rounded>Proximamente</v-btn>
                <!-- <v-btn to="signup" class="btn_price" elevation="2" rounded>Crear cuenta</v-btn> -->
              </div>
            </div>
            <div class="col-price">
              <div class="desc_price_table">
                <div>
                  <p class="title_desc">Tienda online</p>
                  <p>Incluye una página web de ecommerce</p>
                </div>

                <div>
                  <p class="title_desc">Gestión de productos</p>
                  <p>Productos ilimitados</p>
                </div>
                <div>
                  <p class="title_desc">Cuentas para empleados</p>
                  <p>1 Empleado con acceso al panel de control</p>
                </div>
                <div>
                  <p>Atención al cliente.</p>
                </div>
                <div>
                  <p class="title_desc">Canales de venta.</p>
                  <p>
                    Vende en mercados online y en redes sociales. La
                    disponibilidad de los canales de venta varía según el país.
                  </p>
                </div>
                <div>
                  <p>Creación manual de pedidos</p>
                </div>
                <div>
                  <p>Configuración de medios de pago.</p>
                </div>
                <div>
                  <p>Soporte para configurar un dominio personalizado.</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6" sm="6">
          <div class="table_price">
            <div class="col-price">
              <div class="copy_price">
                <p class="price">Próximamente</p>
                <p class="title">Guru eCoomerce</p>
                <!-- <p class="price">{{priceYearGuru | currency}}/{{yearCopy}}</p> -->
                <p class="price">$---/{{yearCopy}}</p>
                <v-btn disabled class="btn_price" elevation="2" raised rounded>Proximamente</v-btn>
              </div>
            </div>
            <div class="col-price">
              <div class="desc_price_table">
                <div>
                  <p class="title_desc">Tienda online</p>
                  <p>Incluye una página web de ecommerce</p>
                </div>
                <div>
                  <p class="title_desc">Multiples tiendas</p>
                  <p>Puedes crear multiples tiendas</p>
                </div>
                <div>
                  <p class="title_desc">Gestión de productos</p>
                  <p>Productos ilimitados</p>
                </div>
                <div>
                  <p class="title_desc">Cuentas para empleados</p>
                  <p>5 Empleado con acceso al panel de control</p>
                </div>
                <div>
                  <p>Atención al cliente.</p>
                </div>
                <div>
                  <p class="title_desc">Canales de venta.</p>
                  <p>
                    Vende en mercados online y en redes sociales. La
                    disponibilidad de los canales de venta varía según el país.
                  </p>
                </div>
                <div>
                  <p>Creación manual de pedidos</p>
                </div>
                <div>
                  <p>Configuración de medios de pago.</p>
                </div>
                <div>
                  <p>Soporte para configurar un dominio personalizado.</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="sect-custom">
        <v-row class="section_info" no-gutters>
          <div class="section_bg_info"></div>
          <v-col cols="12" md="6" sm="12">
            <div class="info_covid">
              <div class="ctn_img_info">
                <v-img
                  aspect-ratio="1.2"
                  max-width="100%"
                  class="section_img_info"
                  contain
                  src="../assets/img/pos-stock-small.jpg"
                />
              </div>
              <div class="ctn_img_info">
                <v-img
                  aspect-ratio="1.2"
                  max-width="100%"
                  class="section_img_info vertical"
                  contain
                  src="../assets/img/covid_19_1x.jpg"
                />
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <div class="info_covid">
              <div class="copy_covid">
                <p class="title_copy_covid">Reactivación económica</p>
                <p>
                  El covid-19 ha traído una grave crisis económica y sanitaria
                  en el año 2020 para el mundo.
                </p>
                <p>
                  Los gobiernos han implementado estrictas medidas de
                  confinamiento para evitar la propagación de los contagios.
                </p>
                <p>
                  Hemos visto como miles de negocios en países y ciudades han
                  cerrado para siempre, así que hemos tomado la decisión de ser
                  parte de aportar nuestros servicios para que sea parte de la
                  solución a la actual coyuntura que nos estamos enfrentando
                  todos los emprendedores y pequeños negocios.
                </p>
                <p>
                  Brindar una plataforma que permita la digitalización de su
                  negocio de una manera fácil e integra donde nuestro fuerte es
                  el conocimiento del comportamiento de los compradores en
                  línea, integrándola en nuestra solución para que sea usada
                  desde el primer momento.
                </p>
              </div>

              <div class="copy_covid">
                <p class="title_big">Experiencia en potenciar sus ventas en internet.</p>
              </div>

              <div class="form_covid">
                <p>
                  Si quieres hacer parte del programa de
                  <b>reactivación económica</b>
                  dale clic en crear cuenta.
                </p>
                <v-btn to="signup" class="btn_acount" elevation="2" raised>CREAR CUENTA COVID-19</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="sect-custom">
        <v-row>
          <v-col cols="12">
            <div class="title_partner">
              <p>Transformese en nuestro aliado o partner.</p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="portrait-col-12" cols="12" md="12" sm="4">
            <div class="copy_partner">
              <div class="ctn_img_partner">
                <v-img
                  aspect-ratio="1.2"
                  max-width="100%"
                  class="section_img_info"
                  contain
                  src="../assets/img/bn_1.jpg"
                />
              </div>
              <p class="copy_title_partner">Hombre de negocios digitales</p>
              <p>
                Se parte de nuestra linea de partner y administrador de
                negocios, ayudando a transformar negocios fisicos a ser un
                negocio digital.
              </p>
            </div>
          </v-col>
          <v-col class="portrait-col-4" cols="12" md="6" sm="4">
            <div class="copy_partner">
              <div class="ctn_img_partner">
                <v-img
                  aspect-ratio="1.2"
                  max-width="100%"
                  class="section_img_info"
                  contain
                  src="../assets/img/bn_2.jpg"
                />
              </div>
              <p class="copy_title_partner">Audiencia</p>
              <p>
                Ser parte de la transformacion economica y el poder de llegar a
                mas clientes para usted y los negocios de sus clientes.
              </p>
            </div>
          </v-col>
          <v-col class="portrait-col-4" cols="12" md="6" sm="4">
            <div class="copy_partner">
              <div class="ctn_img_partner">
                <v-img
                  aspect-ratio="1.2"
                  max-width="100%"
                  class="section_img_info"
                  contain
                  src="../assets/img/bn_3.jpg"
                />
              </div>
              <p class="copy_title_partner">Habilidades y mejores ingresos</p>
              <p>
                Sea parte de capacitaciones y mejoramientos de habilidades para
                que pueda desarrollar un negocio y mejores ingresos economicos
                siendo nuestro aliado.
              </p>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Price",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      active: false,
      valuePrice: 75000,
      pricePlan2: 308000,
      yearCopy: "Mes"
    };
  },
  methods: {
    linkCall() {
      return "price_isActive";
    },
    yearFunction() {
      if (this.active === true) {
        this.yearCopy = "Año";
      } else {
        this.yearCopy = "Mes";
      }
    }
  },
  created() {
    this.linkCall();
  },
  computed: {
    priceYearGuru() {
      if (this.active === true) {
        const vla = this.pricePlan2 * 12 - 20000;
        this.yearFunction();
        return vla;
      } else {
        this.yearFunction();
        return this.pricePlan2;
      }
    },
    priceYear() {
      if (this.active === true) {
        const vla = this.valuePrice * 12 - 20000;
        this.yearFunction();
        return vla;
      } else {
        this.yearFunction();
        return this.valuePrice;
      }
    }
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Precios para Lubumas",
    // all titles will be injected into this template
    titleTemplate: "%s | Plataforma de eCommerce",
    meta: [
      { charset: "utf-8" },
      {
        property: "og:image",
        content: "https://lubumas.com/img/space3_facebook.png"
      },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://lubumas.com/"
      },
      {
        property: "og:title",
        content: "Lubumas - Plataforma de eCommerce"
      },
      {
        property: "og:description",
        content:
          "Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio."
      },

      { property: "og:site_name", content: "lubumas" },
      // Twitter card
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "https://lubumas.com/"
      },
      { name: "twitter:title", content: "Lubumas | Plataforma de eCommerce" },
      {
        name: "twitter:description",
        content:
          "Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio"
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "@diegoachury" },
      {
        name: "twitter:image:src",
        content: "https://lubumas.com/img/space3_facebook.png"
      },
      // Google / Schema.org markup:
      { itemprop: "name", content: "Lubumas | Plataforma de eCommerce" },
      {
        itemprop: "description",
        content:
          "Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio"
      },
      {
        itemprop: "image",
        content: "https://lubumas.com/img/space3_facebook.png"
      }
    ]
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/base.scss";
.hero_price {
  display: flex;
  position: relative;
  background-color: $bg-hero;
  min-height: 300px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  @media #{$large-up} {
    min-height: 400px;
  }
  &::after {
    content: "";
    opacity: 0.2;
    position: absolute;
    height: 100%;
    width: 100%;
    background: url("../assets/img/price_bg.png") no-repeat;
    background-position: center;
    background-size: cover;

    @media #{$large-up} {
      background-size: 100%;
    }
    //transform: rotate(270deg);
  }
  .copy_hero_price {
    padding: 50px 0;
    width: 80%;
    text-align: center;
    @media #{$large-up} {
      width: 50%;
    }
    h1 {
      color: #114b5f;
      line-height: 1.2;
      font-size: 3rem;
      margin-bottom: 10px;
      span {
        color: #114b5f;
      }
    }
    p {
      font-size: 1.2rem;
    }
  }
}
.table_price {
  display: flex;
  flex-direction: column;
  text-align: center;
  @media #{$large-up} {
    text-align: left;
    flex-direction: column;
  }
  .col-price {
    .desc_price_table {
      padding: 20px 40px;
      @media #{$large-up} {
        padding-top: 20px;
        padding-left: 10px;
        padding-right: 30px;
      }
      .desc_sect {
        margin-bottom: 20px;
      }
      p {
        font-size: 1rem;
        margin-bottom: 10px;
        font-weight: 300;
        color: #6b7177;
        &.title_desc {
          color: #000;
          font-family: "Roboto", sans-serif;
          font-size: 1rem;
          font-weight: 400;
          margin-bottom: 0px;
          line-height: 1;
        }
      }
    }
    .copy_price {
      padding: 20px;
      @media #{$large-up} {
        text-align: center;
      }
      .btn_price {
        @include price-btn($color-primary-light, $text-site-white, 1rem, 150px);
      }
      p {
        margin-bottom: 0;
        &.title {
          font-family: "Roboto Condensed", sans-serif;
          font-size: 1.3rem;
          line-height: 1;
        }
        &.price {
          font-family: "Roboto Condensed", sans-serif;
          font-weight: bold;
          font-size: 2.1rem;
        }
      }
    }
  }
}
.sect-custom {
  padding-top: 50px;
  @media #{$large-up} {
    padding-bottom: 50px;
  }
  .portrait-col-4 {
    @media #{$tablet-portrait} {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
    @media #{$large-up} {
      flex: 0 0 33.3333333333% !important;
      max-width: 33.3333333333% !important;
    }
  }
  .portrait-col-12 {
    @media #{$tablet-portrait} {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    @media #{$large-up} {
      flex: 0 0 33.3333333333% !important;
      max-width: 33.3333333333% !important;
    }
  }
  .title_partner {
    p {
      text-align: center;
      font-size: 2.2rem;
    }
  }
  .copy_partner {
    padding: 20px 20px;
    border-radius: 2px;
    transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1),
      background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),
      color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    &:hover {
      box-shadow: $shadow-3;
    }
    .ctn_img_partner {
      .v-responsive.v-image .v-image__image {
        background-size: cover !important;
      }
      .v-image.section_img_info {
        border-radius: 4px;
        height: 240px !important;
        width: 100% !important;
        //box-shadow: $shadow-3;
      }
    }
    p {
      padding-top: 10px;
      color: #000;
      font-weight: 300;
      margin-bottom: 5px;
      line-height: 1.3;
      font-size: 1rem;
      &.copy_title_partner {
        font-size: 1.2rem;
        font-family: "Roboto Condensed", sans-serif;
      }
    }
  }
  .section_info {
    position: relative;
    // display: flex;
    // flex-direction: row;
    // flex: 1 1 auto;
    .col-info {
      max-width: 50%;
    }

    .section_bg_info {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #fbf7ed;
      @media #{$large-up} {
        height: 100%;
        right: 0;
        width: 80%;
      }
    }
    .info_covid {
      padding: 20px;
      position: relative;
      z-index: 1;
      .ctn_img_info {
        text-align: right;
        margin-bottom: 20px;
        .v-responsive.v-image .v-image__image {
          background-size: cover !important;
        }
        .v-image.section_img_info {
          height: 320px !important;
          width: 500px !important;
          border-radius: 4px !important;
          box-shadow: $shadow-3;
          display: none;
          @media #{$large-up} {
            display: block;
          }
          &.vertical {
            //left: 10%;
            display: block;
            box-shadow: $shadow-2;
            width: 100% !important;
            @media #{$large-up} {
              float: right;
              right: 10%;
              width: 300px !important;
            }
          }
        }
      }
      .copy_covid {
        padding-top: 20px;
        p {
          &.title_copy_covid {
            font-family: "Roboto Condensed", sans-serif;
            font-weight: 700;
            font-size: 1.2rem;
            text-transform: uppercase;
          }
          &.title_small {
            font-size: 1.2rem;
            font-weight: 600;
            line-height: 1.2;
            color: #000;
            margin-bottom: 5px;
          }
          &.title_big {
            font-size: 2rem;
            line-height: 1.2;
            width: 80%;
            color: $text-purple;
            margin-bottom: 20px;
          }
        }
      }
      .form_covid {
        border-radius: 2px;
        box-shadow: $shadow-2;
        padding: 30px 20px;
        background-color: $bg-header;
        p {
          color: #fff;
          font-size: 1rem;
        }
        a.v-btn.btn_acount {
          //background-color: $color-primary-light !important;
          @include price-btn(
            $color-primary-light,
            $text-site-white,
            1rem,
            150px
          );
        }
      }
    }
  }
}
.switch_periodo {
  padding-top: 20px;
  justify-content: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media #{$tablet-up} {
    margin-bottom: 20px;
  }
  p {
    font-family: "Roboto Condensed", sans-serif;
    margin: 0 !important;
    padding: 0 10px;
    line-height: 0;
  }
}
.hero_price_title {
  padding: 50px 0 20px;
  margin: 0 auto;
  text-align: center;
  @media #{$tablet-up} {
    width: 80%;
  }
  h1 {
    font-size: 2.8rem;
    font-weight: 400;
    line-height: 1.1;
    text-align: center;
    font-family: "Roboto", sans-serif;
    b {
      color: $text-purple-light;
    }
  }
}
</style>
